export type Computed<T> = T extends object ? { [K in keyof T]: T[K] } : T;

type ValueOf<T> = T[keyof T];
type NonEmptyArray<T> = [T, ...T[]];
type MustInclude<T, U extends T[]> = [T] extends [ValueOf<U>] ? U : never;

/**
 * Converts a string union type to a type-safe array you statically build.
 * This is useful for when you want to check if a string exists as a key from a given type.
 */
export const stringUnionToArray = <T>() => {
  return <U extends NonEmptyArray<T>>(...elements: MustInclude<T, U>) => elements;
};
